// components/FormWrapper.tsx
'use client' // Enables usage of client-side features in Next.js (e.g., hooks or browser APIs)

import React from 'react'

// Define props for the FormWrapper component
interface FormWrapperProps {
  // Callback to handle form submission event
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void

  // Children elements to be rendered inside the form (e.g., input fields, buttons)
  children: React.ReactNode
}

// Stateless functional component to wrap forms with consistent styling and behavior
const FormWrapper: React.FC<FormWrapperProps> = ({ onSubmit, children }) => {
  return (
    // HTML form element with provided submit handler and Tailwind spacing between children
    <form onSubmit={onSubmit} className='space-y-4'>
      {children} {/* Render all form elements passed as children */}
    </form>
  )
}

export default FormWrapper // Exporting the component for use in other parts of the application
